import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

const canvas = document.querySelector('canvas.webgl')
const scene = new THREE.Scene()

const geometry = new THREE.BoxGeometry(1, 1, 1, 2, 2, 2)
const material = new THREE.MeshBasicMaterial({ color: '#a778d8', wireframe: true })
const mesh = new THREE.Mesh(geometry, material)
scene.add(mesh)

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1000)
camera.position.z = 500;
camera.rotation.x = 45;
camera.position.y = 0;
camera.lookAt(0,0,0);
scene.add(camera)

function createGrid()
{
    const vertices = [], colors = [];

    let size = 150;
    let halfSize = size * 0.5;
    let separation = 10;
    let steps = size / separation;
    for(var i=-halfSize, iStep = 0; iStep <= steps; iStep++, i+=separation)
    {
        for(var j=-halfSize, jStep = 0; jStep <= steps; jStep++, j+=separation)
        {
            for(var k=-halfSize, kStep = 0; kStep <= steps; kStep++, k+=separation)
            {
                if(iStep<steps)
                {
                    vertices.push(i,j,k, i+separation, j, k);
                    colors.push(iStep/steps,jStep/steps,kStep/steps);
                    colors.push((iStep+1)/steps,jStep/steps,kStep/steps);
                } 
                if(jStep<steps)
                {
                    vertices.push(i,j,k, i, j+separation, k);
                    colors.push(iStep/steps,jStep/steps,kStep/steps);
                    colors.push(iStep/steps,(jStep+1)/steps,kStep/steps);
                }
                if(kStep<steps)
                {
                    vertices.push(i,j,k, i, j, k+separation);
                    colors.push(iStep/steps,jStep/steps,kStep/steps);
                    colors.push(iStep/steps,jStep/steps,(kStep+1)/steps);
                }
            }
        }
    }
    
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
    geometry.setAttribute( 'color', new THREE.Float32BufferAttribute( colors, 3 ) );

    const material = new THREE.LineBasicMaterial( { vertexColors: true, toneMapped: false } );

    const lineSegments = new THREE.LineSegments(geometry,material);
    scene.add(lineSegments);
}

const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const clock = new THREE.Clock()

let angle = 0;
let cameraUp = true;

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    angle+=0.01;

    camera.position.x = Math.cos(angle)*200;
    camera.position.z = Math.sin(angle)*200;
    
    camera.position.y += cameraUp ? 0.5 : -0.5;
    if(cameraUp && camera.position.y > 200)
    {
        cameraUp = false;
    }
    else if(!cameraUp && camera.position.y < -200)
    {
        cameraUp = true;
    }
    camera.lookAt(0,0,0);

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}


createGrid();
tick()